module.exports = __webpack_public_path__ + "img/hongbao_2.c710c7ca.png";